import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { STUDIO } from "@/lib/studio";

const H = ({ children }) => <h3 className="mt-6 font-serif text-xl text-ink">{children}</h3>;
const P = ({ children }) => <p className="mt-2 text-sm leading-relaxed text-ink-soft">{children}</p>;
const Ph = ({ children }) => <span className="rounded bg-gold/15 px-1 text-gold-deep">[{children}]</span>;

export const Impressum = () => (
  <div data-testid="impressum-content">
    <H>Angaben gemäß § 5 DDG</H>
    <P>
      Maison Princess – Beauty · Wellness · Selfcare<br />
      Inhaberin: {STUDIO.owner}<br />
      {STUDIO.street}<br />
      {STUDIO.city}<br />
      Deutschland
    </P>
    <H>Kontakt</H>
    <P>
      Telefon: <a href={STUDIO.phoneHref} className="text-gold-deep underline underline-offset-4">{STUDIO.phone}</a><br />
      E-Mail: <a href={`mailto:${STUDIO.email}`} className="text-gold-deep underline underline-offset-4">{STUDIO.email}</a><br />
      Website: www.maisonprincess.org
    </P>
    <H>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H>
    <P>{STUDIO.owner}, {STUDIO.street}, {STUDIO.city}</P>
    <H>Verbraucherstreitbeilegung</H>
    <P>Ich bin nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</P>
    <H>Haftung für Links</H>
    <P>Diese Website enthält Links zu externen Websites Dritter (z. B. Google Maps), auf deren Inhalte ich keinen Einfluss habe. Für diese Inhalte ist stets der jeweilige Anbieter verantwortlich.</P>
    <H>Hinweis zu den Leistungen</H>
    <P>Die angebotenen Gesichts-, Körper- und Wellnessbehandlungen sind kosmetische Pflege- und Wellnessanwendungen und ersetzen keine ärztliche Diagnose oder Behandlung.</P>
    <H>Bildnachweis</H>
    <P>Studiofotos (Gesichtsbehandlung, Fachfußpflege): Maison Princess. Weitere Fotos: Unsplash und Pexels (lizenzfreie Bilder); Bild „G8 Body Contouring“: KI-generiert. Logo: Maison Princess.</P>
  </div>
);

export const Datenschutz = () => (
  <>
    <H>1. Verantwortliche</H>
    <P>{STUDIO.owner}, Maison Princess, {STUDIO.street}, {STUDIO.city}<br />E-Mail: {STUDIO.email} · Telefon: {STUDIO.phone}</P>
    <H>2. Grundsätze</H>
    <P>Diese Website verwendet keine Cookies, keine Analyse- oder Tracking-Dienste und keine Social-Media-Plugins. Schriftarten werden lokal von diesem Server geladen; es findet keine Verbindung zu Google Fonts statt.</P>
    <H>3. Hosting und Server-Logfiles</H>
    <P>Beim Aufruf der Website verarbeitet der Hosting-Anbieter technisch notwendige Daten (z. B. IP-Adresse, Datum und Uhrzeit, aufgerufene Seite, Browsertyp), um die Website sicher und stabil bereitzustellen (Art. 6 Abs. 1 lit. f DSGVO). Hosting-Anbieter: <Ph>Name und Anschrift des Hosting-Anbieters eintragen</Ph></P>
    <H>4. Terminanfrage per E-Mail</H>
    <P>Das Terminanfrageformular übermittelt keine Daten an diesen Server. Beim Absenden wird lediglich dein eigenes E-Mail-Programm auf deinem Gerät mit einer vorbereiteten Nachricht geöffnet. Erst wenn du diese E-Mail selbst absendest, erhalte ich deine Angaben (Name, E-Mail-Adresse, ggf. Telefonnummer, gewünschte Behandlung, Wunschtermin und Nachricht). Ich verwende sie ausschließlich zur Bearbeitung deiner Anfrage und zur Terminabstimmung (Art. 6 Abs. 1 lit. b DSGVO). Bitte übermittle keine ausführlichen Gesundheitsdaten per E-Mail – diese besprechen wir persönlich.</P>
    <H>5. Kontakt per E-Mail oder Telefon</H>
    <P>Wenn du mich per E-Mail oder Telefon kontaktierst, verarbeite ich deine Angaben zur Bearbeitung deines Anliegens. Die Daten werden gelöscht, sobald sie nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten bestehen.</P>
    <H>6. Externe Links</H>
    <P>Der Link „Route planen“ führt zu Google Maps. Erst beim Anklicken wirst du zu Google weitergeleitet; dort gelten die Datenschutzbestimmungen von Google.</P>
    <H>7. Deine Rechte</H>
    <P>Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch (Art. 15–21 DSGVO). Außerdem kannst du dich bei einer Datenschutz-Aufsichtsbehörde beschweren, z. B. beim Hessischen Beauftragten für Datenschutz und Informationsfreiheit.</P>
    <P>Stand: Oktober 2026</P>
  </>
);

export const LegalDialog = ({ open, onClose }) => (
  <Dialog open={!!open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent data-testid={`legal-dialog-${open || "closed"}`} data-lenis-prevent className="max-h-[85vh] max-w-2xl overflow-y-auto border-gold/30 bg-paper">
      <DialogHeader>
        <DialogTitle className="font-serif text-3xl font-normal text-ink">{open === "impressum" ? "Impressum" : "Datenschutzerklärung"}</DialogTitle>
        <DialogDescription className="text-ink-soft">Maison Princess · Bensheim</DialogDescription>
      </DialogHeader>
      {open === "impressum" ? <Impressum /> : <Datenschutz />}
      <a href={`/${open || "datenschutz"}`} target="_blank" rel="noopener noreferrer" className="mt-6 inline-block text-sm text-gold-deep underline underline-offset-4">Als eigene Seite öffnen</a>
    </DialogContent>
  </Dialog>
);
